module.exports = __webpack_public_path__ + "static/media/PRT.83fd8b23.svg";